// extracted by mini-css-extract-plugin
export default {"heading":"CaseExpansion_heading__q7diw","divider":"CaseExpansion_divider__-xWsw","expansion":"CaseExpansion_expansion__wmjV7"};